"use client"
import React, { useEffect, useState } from "react"
import Header from "../../../layout/landing/desktop/app-bar"
import Head from "next/head"
import {
  Container,
  Grid,
  InputAdornment,
  TextField,
  alpha,
  useTheme,
  Typography,
  Button,
  Box,
  ToggleButtonGroup,
  ToggleButton
} from "@mui/material"
import AppStickSection from "../../../AppStickSection"
import { CardPos } from "iconsax-react"
import { useForm } from "react-hook-form"
import ValidationHelperText from "../../../common/validation-helper-text"
import { useRouter } from "next/router"
import Payment from "../payment"

function DesktopDirectPayment({ paymentUrl }) {
  const theme = useTheme()
  const router = useRouter()
  const [paymentStatus, setPaymentStatus] = useState("1")
  let profileData
  if (typeof window !== "undefined") {
    profileData = localStorage.getItem("user")
  }
  useEffect(() => {
    if (profileData && !parseInt(paymentUrl)) {
      setPaymentStatus("2")
    }
  }, [profileData, paymentUrl])

  const handleChangeReqType = (event, newAlignment) => {
    if (newAlignment) {
      setPaymentStatus(newAlignment)
    } else {
      return false
    }
  }

  const {
    control,
    handleSubmit,
    register,
    reset,
    getValues,
    setValue,
    formState: { errors }
  } = useForm()

  useEffect(() => {
    if (paymentUrl && paymentUrl !== "0") {
      setValue("paymentId", paymentUrl)
    } else {
      setValue("paymentId", "")
    }
  }, [])

  const onSubmit = () => {
    router.push(`installment/${getValues("paymentId")}`)
  }

  return (
    <>
      <Header isOtherPages={true} />
      <Head>
        <title>پرداخت اقساط</title>
      </Head>

      <Container
        sx={{
          padding: "1rem",
          mb: 6,
          pb: 2,
          bgcolor: "#ebebeb",
          borderRadius: "1rem",
          display: { xs: "block", md: "block", lg: "block", xl: "block" }
        }}
        id='acceptors'
      >
        <AppStickSection title={"پرداخت اقساط"} />
        {profileData && Object.keys(profileData).length > 0 && (
          <Box width={"100%"} textAlign={"center"} marginTop={"2rem"}>
            <Grid container spacing={2} justifyContent={"center"}>
              <Grid item md={12} xs={12}>
                <ToggleButtonGroup
                  defaultValue={"2"}
                  color='primary'
                  value={paymentStatus}
                  exclusive
                  onChange={handleChangeReqType}
                  aria-label='Platform'
                >
                  <ToggleButton value='2'>پرداخت قسط خودم</ToggleButton>
                  <ToggleButton value='1'>پرداخت با شماره تسهیلات</ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            </Grid>
          </Box>
        )}
        {paymentStatus === "1" ? (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box marginTop={"2rem"} textAlign={"center"}>
              <Typography variant='body1' color='initial'>
                کاربر گرامی لطفا شماره تسهیلات مورد نظر خود را وارد کرده و جهت پرداخت اقساط اقدام نمایید
              </Typography>
              <Box height={"50vh"}>
                <Box mt={2}>
                  <TextField
                    label='شماره تسهیلات'
                    fullWidth
                    dir='ltr'
                    inputProps={{ maxLength: 15 }}
                    name='paymentId'
                    InputLabelProps={
                      paymentUrl.length
                        ? {
                            shrink: true
                          }
                        : {
                            shrink: false
                          }
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start'>
                          <CardPos size={20} color={theme.palette.primary.dark} />
                        </InputAdornment>
                      )
                    }}
                    sx={{
                      caretColor: theme.palette.secondary.main,
                      width: "50%",
                      "& .MuiInputBase-root": {
                        borderRadius: "8px",
                        backgroundColor: alpha(theme.palette.grey[200], 0.5)
                      }
                    }}
                    {...register("paymentId", {
                      required: {
                        value: true,
                        message: "شماره تسهیلات الزامی است"
                      }
                    })}
                  />
                  <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
                    <ValidationHelperText error={!!errors?.paymentId} helperText={errors?.paymentId?.message} />
                    <Box width={"30%"} mt={2}>
                      <Button
                        type='submit'
                        variant='contained'
                        size='large'
                        sx={{ borderRadius: "8px" }}
                        disableElevation
                        fullWidth
                      >
                        پرداخت قسط
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </form>
        ) : (
          <Payment />
        )}
      </Container>
    </>
  )
}

export default DesktopDirectPayment
